var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.6077C9.71282 -0.535899 14.2872 -0.535898 18 1.6077C21.7128 3.75129 24 7.71281 24 12C24 16.2872 21.7128 20.2487 18 22.3923C14.2872 24.5359 9.71282 24.5359 6 22.3923C2.28719 20.2487 0 16.2872 0 12C0 7.71281 2.28719 3.75129 6 1.6077Z",
    fill: "#457EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25555 18.5606C8.16982 18.6129 8.05815 18.5886 8.00179 18.5055L7.78591 18.1872C7.72954 18.1041 7.74847 17.9916 7.82755 17.9297C8.53859 17.3733 9.12305 16.7462 9.5827 16.0746C11.2942 13.5737 11.2942 10.4266 9.5827 7.92565C9.12305 7.254 8.53859 6.6269 7.82755 6.07054C7.74847 6.00866 7.72954 5.89611 7.78591 5.81301L8.00179 5.49471C8.05815 5.41161 8.16982 5.38737 8.25556 5.43964L17.845 11.2853C18.3802 11.6116 18.3802 12.3887 17.845 12.7149L8.25555 18.5606Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmb);
export default __webpack_public_path__ + "static/media/amb.0a1240c7e506430a0907939d0e8e6a0a.svg";
export { ForwardRef as ReactComponent };